import {GetRequest} from "@configs/request";

export const getUI = () => {
    let token = localStorage.getItem('token');
    return dispatch => {
        GetRequest('/general/ui', null, {'Authorization': token})
            .then((response) => {
                if (response) {
                    let result = response.data;
                    if (result.ok && result.data) {
                        result = result.data;
                        localStorage.setItem('menu', JSON.stringify(result.menu));
                        dispatch({
                            type: 'UI',
                            data: result
                        })
                    }
                }
            })
    }
}
